import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// Initial state
const state = {
  webinars: [],
  webinar: {},
  totalPages: 0,
  action: '', // Added to resolve undefined state property issue
};

// Getters
const getters = {
  webinar: (state) => state.webinar,
  webinars: (state) => state.webinars,
  totalPages: (state) => state.totalPages,
};

// Mutations
const mutations = {
  SET_WEBINAR(state, webinar) {
    state.webinar = webinar;
  },

  SET_WEBINARS(state, webinars) {
    state.webinars = webinars;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
};

// Actions
const actions = {
  async getAllwebinars({ commit }, [page, search]) {
    if(hasPermission('webinar')){
      const permission = {
        headers: {
          'X-Permission': 'webinar',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(
            `/admin/webinar?page=${page}&product_id=${productId}&search=${search}`,
            permission
        );
        const res = response.data;
        const totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_WEBINARS', res.data);
      } catch (error) {
        commit('SET_WEBINARS', []);
      }
    }
  },

  async create({}, post) {

    const formData = new FormData();
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('caption', post.caption);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    formData.append('short_description', post.short_description  || '');
    if(hasPermission('webinar')){
      const permission = {
        headers: {
          'X-Permission': 'webinar',
        },
      };

      try {
        const response = await axios.post(
            `/admin/webinar/create?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error creating webinar:', error);
      }
    }
  },

  async update({}, post) {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('id', post.id);
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('short_description', post.short_description || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    if (post.caption !== undefined) {
      formData.append('caption', post.caption);
    }
    if(hasPermission('webinar')){
      const permission = {
        headers: {
          'X-Permission': 'webinar',
        },
      };

      try {
        const response = await axios.post(
            `/admin/webinar/update/${post.slug}?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error updating webinar:', error);
      }
    }
  },

  async view({ commit }, slug) {
    if(hasPermission('webinar')){
      const permission = {
        headers: {
          'X-Permission': 'webinar',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(`/admin/webinar/${slug}/${productId}`, permission);
        commit('SET_WEBINAR', response.data.data);
      } catch (error) {
        console.error('Error fetching webinar:', error);
      }
    }
  },

  async delete({}, webinar) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(`/admin/webinar/delete/${webinar.slug}/${productId}`, {
        '_method': 'DELETE',
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting webinar:', error);
    }
  },

  async publishing({ commit }, payload) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(
        `/admin/webinar/publish/${payload.webinar.slug}/${payload.action}?product_id=${productId}`
      );
      switch (payload.action) {
        case 'publish':
          payload.webinar.published = 1;
          payload.webinar.published_at = 'Just now';
          break;
        case 'unpublish':
          payload.webinar.published = 0;
          payload.webinar.published_at = '';
          break;
      }
      commit('SET_WEBINAR', payload.webinar);
      return response;
    } catch (error) {
      console.error('Error publishing webinar:', error);
    }
  },
};

// Exporting the Vuex module
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
